import { render, staticRenderFns } from "./Autologin.vue?vue&type=template&id=aedde4e8&scoped=true&"
import script from "./Autologin.vue?vue&type=script&lang=js&"
export * from "./Autologin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedde4e8",
  null
  
)

export default component.exports